import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const CUSTOM_MODAL_STYLES = {
    content: { padding: 0, width: 550 },
};

export const StyledButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0 16px 16px;

    & > *:not(:first-child) {
        margin-left: 4px;
    }
`;

export const StyledNameInputLabel = styled.div`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["300"])};

    margin-bottom: 4px;
`;

export const StyledNameInputDescription = styled.div`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["400"])};

    font-style: italic;
    margin-top: 4px;
`;

export const StyledNameInputContainer = styled.div`
    margin-bottom: 32px;
    margin-top: 16px;
    padding: 0 24px;
`;

export const StyledSubtitle = styled.p`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};

    margin: 24px 0 0;
`;

export const StyledTitle = styled.h5`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["500"])};

    margin: 0;
`;

export const StyledHeader = styled.div`
    padding: 20px 24px 0;
`;

export const StyledModalContent = styled.div``;
